import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Receipt } from "lucide-react";
import NotesDeFraisTab from "@/features/rh/notes-de-frais/components/NotesDeFraisTab";

export const Route = createFileRoute("/_app/rh/notes-de-frais/")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS.VIEW),
  staticData: {
    title: "Notes de Frais",
    icon: Receipt,
    tab_icon: Receipt,
    permission: PERMISSIONS.RH.FRAIS.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 60,
    showInNav: true,
    showInTab: true,
  },
  component: NotesDeFraisTab,
});
